import { Box, Button, Typography } from "@mui/material"
import SidebarCollapse from "common/icons/sidebar-collapse.svg"
import SidebarExpand from "common/icons/sidebar-expand.svg"
import { Midnight } from "common/themes/colours"
import * as styles from "./CollapseControl.styles"

type Props = {
    expanded: boolean
    onExpand: () => void
    onCollapse: () => void
}

function Collapse({ onCollapse }: Pick<Props, "onCollapse">) {
    return (
        <Button onClick={onCollapse}>
            <Box css={styles.buttonContent}>
                <Typography variant="headingTinyCaps" color={Midnight[80]}>
                    Collapse
                </Typography>
                <SidebarCollapse />
            </Box>
        </Button>
    )
}

function Expand({ onExpand }: Pick<Props, "onExpand">) {
    return (
        <Button onClick={onExpand}>
            <Box css={styles.buttonContent}>
                <SidebarExpand />
            </Box>
        </Button>
    )
}

export default function CollapseControl({
    expanded,
    onCollapse,
    onExpand,
}: Props) {
    return (
        <Box>
            {expanded ? (
                <Collapse onCollapse={onCollapse} />
            ) : (
                <Expand onExpand={onExpand} />
            )}
        </Box>
    )
}
